import * as React from "react";
import './App.css';
import Body from "./component/body";
import Navbar from "./component/navbar"
function App() {
  return (
    <>
      <Navbar/>
      <Body/>
    </>
  );
}

export default App;
